import { collection, doc, getDoc, getDocs, query, setDoc, updateDoc, increment, orderBy, where, deleteDoc, arrayRemove } from "firebase/firestore";
import { analytics, db } from '../firebase'
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { makeStyles } from "@mui/material";
import MysoreQueen from '../assets/mysore-queen.png'
import Kadaknath from '../assets/kadaknath.png'
import Warrior from '../assets/warrior.png'
import TenderChicken from '../assets/tender-chicken.png'
import PicklesLogo from '../assets/pickle.png'
import EggsLogo from '../assets/eggs.png'
import ThirtyEggsLogo from '../assets/thirty-eggs.png'
import ClassicCountry from '../assets/classic-country.png'
import MuttonWithBone from '../assets/mutton-with-bone.png'
import Nutrisoft from '../assets/nutrisoft.png'
import { logEvent } from "firebase/analytics";
import { Preferences } from '@capacitor/preferences';
import MuttonKeema from '../assets/mutton-keema.png'
import MuttonBoneless from '../assets/mutton-boneless.png'
import * as CryptoJS from 'crypto-js';
import { Capacitor } from "@capacitor/core";

let userDataCache = null

const imgMap = {
  'MysoreQueen' : MysoreQueen,
  'Kadaknath' : Kadaknath,
  'TenderChicken' : TenderChicken,
  'Warrior' : Warrior,
  'PicklesLogo' : PicklesLogo,
  'EggsLogo' : EggsLogo,
  'ThirtyEggsLogo' : ThirtyEggsLogo,
  'ClassicCountry' : ClassicCountry,
  'Nutrisoft' : Nutrisoft,
  'MuttonWithBone': MuttonWithBone,
  'MuttonBoneless' : MuttonBoneless,
  'MuttonKeema' : MuttonKeema
}

export const btnCurvedStyle = {
  borderRadius:'20px', background:'#FFF0D9 !important', color:'#a4243d !important', 
            fontFamily:'Sans', fontWeight:'bold !important', padding:'8px 40px'
}

export const getCustomizedProducts = () => {
  return ['C009', 'C013', 'C017', 'C029', 'C021',  'CC009', 'CC013', 'CC017', 'CC029', 'CC021', 'C019', 'C023', 'C011', 'C016', 'C068', 'C025', 'CC01', 'CC02', 'CO14']
}

export const getAllCategories = () => {
  return [{
    id : 'free-range-birds',
    title : 'Free Range Farm Birds'
  },
  {
    id : 'better-than-broiler-chicken',
    title : 'Better than broiler chicken'
  },
  {
    id : 'eggs',
    title : 'Eggs'
  },
  {
    id : 'pickles',
    title : 'Pickles'
  },
  {
    id : 'mutton',
    title : 'Mutton'
  },
  {
    id : 'Amma-Chethi-Marinades',
    title : 'Marinades'
  }
  ]
}

export const getImgMap = () => {
  return imgMap
}

export const getRecepieVideos = () => {
  return [
    {
      url : 'https://www.youtube.com/embed/F6l2E631Hd0',
      id : 1
    },
    {
      url : 'https://www.youtube.com/embed/52tKR3RkHro',
      id : 2
    },
    {
      url : 'https://www.youtube.com/embed/t__O2836Pak',
      id : 3
    },
    {
      url : 'https://www.youtube.com/embed/nXgtsknIPvY',
      id : 4
    },
    {
      url : 'https://www.youtube.com/embed/SPfE1gXBRhc',
      id : 5
    },
    {
      url : 'https://www.youtube.com/embed/F6l2E631Hd0',
      id : 6
    }
  ]
}

export const getDeliveryCharge = async(type, storeDetails, cartTotal, customerLat, customerLng) => {

  // Self pickup is always free
  if (type === 'self_pickup') {
    return 0
  }

  // Free delivery for orders ≥ ₹999 (for all stores)
  if (cartTotal && cartTotal >= 999) {
    return 0
  }

  // Standard pricing logic for all stores
  const couponData = await Preferences.get({ key: 'couponData'})
  if (couponData.value) {
    if (JSON.parse(couponData.value).couponCode == 'HEALTHYEATS' || JSON.parse(couponData.value).couponCode == 'HEALTHYEGGS') {
      return 99 // Special coupon pricing
    } 
  }
  return 39 // Standard delivery charge for all stores
}


export const getDynamicDeliveryCharge = async(data) => {

  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/getDynamicDeliveryCharge`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      if (data.error) {
        reject(data)
      } else{

        resolve({
          charge: data.deliveryCharge.charge,
          distance: data.deliveryCharge.distance
        })
      }
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
}

/**
 * Create Cashfree PG order (Pilot POST CASHFREE_URL). Webhook + Firestore use order_id.
 * @param {object} body — amount, mobileNo, customerId, platform, orderDetails, version
 * @returns {Promise<{ payment_session_id: string, order_id: string }>}
 */
function getPilotPaymentsBaseUrl() {
  const base = process.env.REACT_APP_PILOT_URL;
  if (!base) {
    throw new Error('REACT_APP_PILOT_URL is required for Cashfree payments');
  }
  return String(base).replace(/\/$/, '');
}

export async function createCashfreeOrder(body) {
  const url = `${getPilotPaymentsBaseUrl()}/api/payments/cashfree/order`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (
    !response.ok ||
    data.error ||
    !data.order_id ||
    !data.payment_session_id
  ) {
    const msg =
      typeof data.error === "string"
        ? data.error
        : data.message || "Failed to create Cashfree order";
    throw new Error(msg);
  }
  return data;
}


export const getMetaData = () => {
  return {
    'exclusive-offers' : {
      title : 'Exclusive Offers',
      keywords : 'Country Chicken, Exclusive Offers',
      description : 'Country Chicken Exclusive Offers'
    },
    'nutrisoft-chicken' : {
      title : 'Nutrisoft Chicken',
      keywords : 'Nutrisoft Chicken',
      description : 'Nutrisoft Chicken'
    },
    'better-than-broiler-chicken' : {
      title : 'Better than broiler chicken',
      keywords : 'Better than broiler chicken',
      description : 'Better than broiler chicken'
    },
    'home' : {
      title : 'Country Chicken Co - Authentic Natu Kodi in Hyderabad',
      keywords : 'countrychicken, natu kodi, healthy chicken, country eggs, chicken pickles, free range, antibiotic, steroids free',
      description : 'Country Chicken Co. brings you authentic natu kodi (country chicken) in Hyderabad. Our free-range chickens are raised without antibiotics. Buy now online and experience the goodness of authentic country chicken, conveniently delivered to your doorstep'
    },
    'free-range-birds' : {
      title : 'Naturally Grown, Free Range, and Healthy Country Chicken (Natu Kodi)',
      keywords : 'Country chicken, natu kodi, free range, naturally grown, near you, beyond organic, healthy Free Range, Naturally Grown',
      description : 'We believe in providing our chickens with a stress-free life. Thats why all our poultry is free-range, allowing them to engage in natural behaviors, roam outdoors, and forage for their food. We follow sustainable farming practices and avoid the use of hormones or antibiotics'
    },
    'village-birds' : {
      title : 'Village Birds: Order Now in Hyderabad for Authentic Natu Kodi (Country Chicken)',
      keywords : 'Country Chicken Co., Village Birds, Order Now, Hyderabad, Authentic Natu Kodi, Backyard-raised Poultry',
      description : 'Discover the Taste of Pure Tradition with Country Chicken Co Village Birds. Located in Hyderabad, we bring you the finest selection of Natu Kodi (Country Chicken) raised by local farmers. Our poultry is free-range and nurtured naturally, offering you an authentic farm-fresh experience. Place your order now to enjoy the natural and healthy goodness of our Village Birds.'
    },
    'chicken-half-kg' : {
      title : 'Naturally Grown, Free Range, and Healthy Country Chicken (Natu Kodi)',
      keywords : 'Country chicken, natu kodi, free range, naturally grown, near you, beyond organic, healthy Free Range, Naturally Grown',
      description : 'We believe in providing our chickens with a stress-free life. Thats why all our poultry is free-range, allowing them to engage in natural behaviors, roam outdoors, and forage for their food. We follow sustainable farming practices and avoid the use of hormones or antibiotics'
    },
    'chicken' : {
      title : 'Naturally Grown, Free Range, and Healthy Country Chicken (Natu Kodi)',
      keywords : 'Country chicken, natu kodi, free range, naturally grown, near you, beyond organic, healthy Free Range, Naturally Grown',
      description : 'We believe in providing our chickens with a stress-free life. Thats why all our poultry is free-range, allowing them to engage in natural behaviors, roam outdoors, and forage for their food. We follow sustainable farming practices and avoid the use of hormones or antibiotics'
    },
    'eggs' : {
      title : 'Finest Free-Range, Cage-Free Brown Eggs and Country Eggs in Hyderabad',
      keywords : 'free-range, cage-free, order now online, lowest price, best quality',
      description : 'Buy The finest free-range, cage-free brown eggs and country eggs in Hyderabad at Country Chicken Co. Order now online for the lowest prices and experience the best quality eggs that are ethically sourced.'
    },
    'pickles' : {
      title : 'Authentic Country Chicken Pickle for Order in Hyderabad',
      keywords: 'country chicken pickle, authentic, finest spices, order, buy now, Hyderabad',
      description : 'Satisfy your cravings with our authentic Country Chicken Pickle. Made with the finest spices and locally sourced chicken, order now for quick delivery in Hyderabad. Experience the irresistible taste of tradition.'
    },
    'recipes' : {
      title : 'Finest Natukodi Recipes',
      keywords : 'Country Chicken Co., Natukodi recipes, finest flavors, traditional favorites, innovative creations, delicious possibilities',
      description : 'Explore our curated collection featuring traditional favorites and innovative creations that will tantalize your taste buds. Join our vibrant community of food enthusiasts as we unlock a world of delicious possibilities with the best Natukodi flavors.'
    },
    'mutton': {
      title : 'Mutton',
      keywords : 'Mutton',
      description : 'Discover Country Chicken Co\'s mutton in Hyderabad: the tenderest, tastiest, and juiciest mutton you\'ll ever taste. Experience the flavour of Hyderabad\'s finest mutton today!'
    },
    'Amma-Chethi-Marinades': {
      title : 'Marinades',
      keywords : 'Marinades, country chicken marinades'
    }
  }
}

export const logAction = (key, value) => {
  if (value)
    logEvent(analytics, key, {value : value})
  else
    logEvent(analytics, key)
}

export const getUiProductsData = (products) => {

  if (products.length) {

    products.forEach((order, index) => {

      const tempSpecifications = {}
      let extrasTotal = 0

      order.products.forEach((item) => {
        if (item.parent_code) {

          if (tempSpecifications[item.parent_code]) tempSpecifications[item.parent_code].push(item)
          else tempSpecifications[item.parent_code] = [item]         
          extrasTotal = extrasTotal +  (item.price || 0)     
        } else {
          if (order.uiProducts) order.uiProducts.push(item)
          else order.uiProducts = [item]
        }
      })

      order.extrasTotal = extrasTotal
      order.specifications = tempSpecifications
    })
  } else {
    return []
  }
  return products
}



export const setUserData = (async(userData) => {
  const userCollRef = collection(db, 'users')

  return new Promise((resolve, reject)=> {
    setDoc(doc(userCollRef, userData.userId), userData).then((querySnapshot) => {
      resolve(userData)
    }).catch((error)=> {
      reject(error)
    })
  })
})

export const createNewUser = (async(userData) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/createNewuser`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({
        userData : userData
      })
    }).then((response) => response.json())
    .then(function(data) { 
      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})


export const createNewOrder = (async(orderData) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/createNewOrder`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json",
        "Authorization": `${(await Preferences.get({key : 'NID'})).value || ''}`,
        "platform": Capacitor.getPlatform()
      },
      "body": JSON.stringify({
        userData : orderData
      })
    }).then((response) => response.json())
    .then(function(data) { 

      if (data.ERR_CODE) {
        throw new Error('ERROR')
      }

      if (data.errorCode) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})

// Simple function for parallel testing - sends pre-built order data to Pilot Dashboard
export const createPilotOrder = async (orderData) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Call Pilot API endpoint with pre-built data
      const response = await fetch(`${process.env.REACT_APP_PILOT_URL}/api/orders/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "accept": "application/json"
        },
        body: JSON.stringify(orderData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(`Pilot API error: ${data.message || 'Unknown error'}`);
      }

      console.log('Pilot order created successfully:', data);
      resolve(data);
    } catch (error) {
      console.error('Pilot order creation failed:', error);
      reject(error);
    }
  });
}


export const getUserProductOrders = (async(userData) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/getUserOrders`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json",
        "Authorization": `${(await Preferences.get({key : 'NID'})).value || ''}`,
        "platform": Capacitor.getPlatform()
      },
      "body": JSON.stringify({userData : userData})
    }).then((response) => response.json())
    .then(function(data) { 

      if (data.ERR_CODE) {
        throw new Error('ERROR')
      }

      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})


export const getUserPilotOrders = (async(userData) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_PILOT_URL}/api/users/${userData.userId}/orders`, {
      "method": "GET",
    }).then((response) => response.json())
    .then(function(data) { 

      if (data.success == false) {
        throw new Error('ERROR')
      }

      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})


export const getLanding = (async(userData) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v2/getLanding`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({userData : userData})
    }).then((response) => response.json())
    .then(function(data) { 
      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getCategoryData = (async(key) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getCategoryData`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({id : key})
    }).then((response) => response.json())
    .then(function(data) { 
      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getCartSuggestions = async (cartData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const pilotBase = (process.env.REACT_APP_PILOT_URL || '').replace(/\/$/, '')
      const response = await fetch(`${pilotBase}/api/cart/suggestions`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "accept": "application/json"
        },
        body: JSON.stringify({ cartData })
      })
      
      const data = await response.json()
      
      if (data.error) {
        reject(data)
      } else {
        resolve(data)
      }
    } catch (error) {
      console.log('Error in getCartSuggestions:', error)
      reject(error)
    }
  })
}

export const getNearestStoreDetails = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getNearestStoreDetails`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      if (data.error) {
        reject(data)
      } else
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})


export const getProductData = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v2/getProductData`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const generateSignupOtp = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/generateSignupOtp`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})


export const validateUserOtp = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const landingResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/validateUserOtp`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})



export const getCoupons = (async(data) => {
  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_PILOT_URL}/api/coupons/cccAppFormat`, {

    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const validateCoupon = async (mobile, code, skus, cartTotal) => {
  const response = await fetch(
    `${process.env.REACT_APP_PILOT_URL}/api/coupons/validate-coupon`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({ mobile, code, skus, cartTotal }),
    }
  )
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(data?.message || "Invalid coupon")
    error.status = response.status
    error.data = data
    throw error
  }
  return data
}

export const getBlogData = (async(urlId, postId) => {
  return new Promise((resolve, reject)=> {
    // If postId is provided, get the blog post directly by ID
    if (postId) {
      getDoc(doc(db, `blogPosts/${postId}`)).then((docSnap) => {
        if (docSnap.exists()) {
          resolve({ id: docSnap.id, ...docSnap.data() });
        } else {
          reject({ error: "Blog post not found" });
        }
      }).catch((error)=> {
        console.error("Error fetching blog post by ID:", error);
        reject(error);
      });
      return;
    }
    
    // Otherwise, fetch by urlId
    getDocs(query(collection(db, `blogPosts`), where("urlId", "==", urlId))).then((querySnapshot) => {
      if (querySnapshot.empty) {
        reject({ error: "Blog post not found" });
        return;
      }
      let blogPost = null;
      querySnapshot.forEach((doc) => {
        blogPost = { id: doc.id, ...doc.data() };
      });
      resolve(blogPost);
    }).catch((error)=> {
      console.error("Error fetching blog post:", error);
      reject(error);
    });
  });
});

export const getRecipieData = (async(id) => {
  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getRecipieDetail
    `, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({recipieId : id})
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getAllBlogPosts = (async() => {
  return new Promise((resolve, reject)=> {
    getDocs(query(collection(db, `blogPosts`), orderBy("createdAt", "desc"))).then((querySnapshot) => {
      let blogPosts = [];
      querySnapshot.forEach((doc) => {
        blogPosts.push({ id: doc.id, ...doc.data() });
      });
      resolve(blogPosts);
    }).catch((error)=> {
      console.error("Error fetching blog posts:", error);
      reject(error);
    });
  });
});

export const createBlogPost = (async(blogData) => {
  return new Promise((resolve, reject)=> {
    // Check if URL ID is unique
    getDocs(query(collection(db, `blogPosts`), where("urlId", "==", blogData.urlId))).then((querySnapshot) => {
      if (!querySnapshot.empty) {
        reject({ error: "URL ID already exists. Please choose a unique URL ID." });
        return;
      }
      
      // Add timestamp
      const blogPostWithTimestamp = {
        ...blogData,
        createdAt: new Date()
      };
      
      // Add the blog post
      const blogRef = doc(collection(db, "blogPosts"));
      setDoc(blogRef, blogPostWithTimestamp).then(() => {
        resolve({ id: blogRef.id, ...blogPostWithTimestamp });
      }).catch((error) => {
        console.error("Error creating blog post:", error);
        reject(error);
      });
    }).catch((error) => {
      console.error("Error checking URL uniqueness:", error);
      reject(error);
    });
  });
});

export const checkUrlIdExists = (async(urlId) => {
  return new Promise((resolve, reject)=> {
    getDocs(query(collection(db, `blogPosts`), where("urlId", "==", urlId))).then((querySnapshot) => {
      resolve(!querySnapshot.empty);
    }).catch((error)=> {
      console.error("Error checking URL ID:", error);
      reject(error);
    });
  });
});

export const newCustomerEnquiry = (async(data) => {
  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/newCustomerEnquiry`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})








// Should remove id and fetch from cookie
export const getUserData = (async(id, verifyToken) => {
  // console.log("getting user data for : ", id)
  // if (userDataCache) 
  // {
  //   if (userDataCache.mobileNo == id) {
  //     // console.log("User cache exists : ", userDataCache)
  //     return userDataCache
  //   }
  // }

  return new Promise((resolve, reject)=> {
    getDoc(doc(db, `users/${id}`)).then((querySnapshot) => {

      const deviceToken = document.cookie.replace(/(?:(?:^|.*;\s*)deviceToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      if (verifyToken && deviceToken && (deviceToken != querySnapshot.data().deviceToken.replace(/[^a-zA-Z0-9]/g, ""))) {
        resolve({
          multiLoginError :true
        })
      }

      resolve(querySnapshot.data())
      //TODO - remove

      userDataCache = querySnapshot.data()
    }).catch((error)=> {
      reject(null)
    })
  })
})

export const removeUserCache = (() => {
  userDataCache = null
})

export const getUserDataByUrl = (async(id) => {

  return new Promise((resolve, reject)=> {
    getDocs(query(collection(db, "users"), where("userUrlId", "==", id))).then((querySnapshot) => {
      let userData = null
      querySnapshot.forEach((doc) => {
        userData = doc.data()
      })
      if (userData)
        resolve(userData)
      else  
        reject(null)
    }).catch((error) => {
      reject(error)
    })
  })
})

export const updateUserData = (async(userData, uid) => {
  const userCollRef = collection(db, 'users')
  return new Promise((resolve, reject)=> {
    updateDoc(doc(userCollRef, uid), userData).then((querySnapshot) => {
      resolve(userData)
      removeUserCache()
    }).catch((error)=> {
      reject(error)
    })
  })
})

export const uploadImage = (async(fileData, fileMetadata, fileName, path) => {
  const storage = getStorage();
  const storageRef = ref(storage, `${path}/${fileName}`);

  let metadata = {
    contentType: fileMetadata.type,
  };

  return new Promise((resolve, reject) => {
    uploadBytes(storageRef, fileData, metadata).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        resolve(downloadURL)
      })
    })
  })
})

export const sendNewNotification = (async(data) => {

  const alertCollRef = collection(db, 'alerts'),
        alertId = doc(alertCollRef).id
  data.uid = alertId

  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/sendNotification`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})

export const refreshNoti = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/refreshNotifications`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})

export const registerToken = (async(tokenId, groups) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/subscribe`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({
        tokenId : tokenId,
        groups : groups
      })
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})


export const unRegisterToken = (async(tokenId, groups) => {
  return new Promise(async(resolve, reject) => {
    const orderResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/unsubscribe`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({
        tokenId : tokenId,
        groups : groups
      })
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})


export const checkAppUpdates = (async(versionData) => {
  return new Promise(async(resolve, reject) => {
    const appUpdateResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/appVersionCheck`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({
        appVersion : versionData.appVersion
      })
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    }); 
  })
})

export const addNewAddress = (async(data) => {
  const addrCollRef = collection(db, `users/${data.userId}/address`)
  data.addressId    = doc(addrCollRef).id

  return new Promise((resolve, reject)=> {
    setDoc(doc(addrCollRef, data.addressId), data).then((querySnapshot) => {
      resolve({})
    }).catch((error)=> {
      reject(error)
    })
  })
})


//Might not be used anymore, just leaving here for reference
export const getAllUserAddress = (async(userId) => {
  return new Promise((resolve, reject) => {
    getDocs(query(collection(db, `users/${userId}/address`))).then((querySnapshot) => {
      let eventItems = []
      querySnapshot.forEach((doc) => {
        eventItems.push(doc.data())      
      })
      resolve(eventItems)
    }).catch(()=> {
      reject([])
    })
  })
})

export const getUserDeliveryData = (async(userId) => {
  return new Promise(async(resolve, reject) => {
    const appUpdateResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getUserAddress`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json",
        "Authorization": `${(await Preferences.get({key : 'NID'})).value || ''}`,
        "platform": Capacitor.getPlatform()
      },
      "body": JSON.stringify({
        userId :userId,
        customerId : `${(await Preferences.get({key : 'customerId'})).value || ''}`
      })
    }).then((response) => response.json())
    .then(function(data) { 

      if (data.ERR_CODE) {
        throw new Error('ERROR')
      }

      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getBranchInfo = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const appUpdateResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getBranchInfo`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getAllRecipiesData = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const appUpdateResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getRecipies`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const handleDeviceToken = (async(data) => {
  return new Promise(async(resolve, reject) => {
    const appUpdateResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/handleDeviceToken`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getUserProfileData = (async(userId) => {
  return new Promise((resolve, reject) => {
    getDoc(doc(db, `users/${userId}`)).then((querySnapshot) => {
      resolve(querySnapshot.data())
    }).catch((error)=> {
      reject(null)
    })
  })
})

export const getOrdersById = (async(userId) => {
  return new Promise((resolve, reject) => {
    getDocs(query(collection(db, `orders`),
                   where('userId', '==', userId),
                   orderBy('timeStamp', 'desc'))
            ).then((querySnapshot) => {
      let eventItems = []
      querySnapshot.forEach((doc) => {
        eventItems.push(doc.data())      
      })
      resolve(eventItems)
    }).catch((error)=> {
      console.log(error)
      reject([])
    })
  })
})

export const getInputTheme = () => {

  return {
    inputBox : {
      "& .MuiOutlinedInput-input" : {
        color:'white !important'
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "white"
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "white"
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "white"
      },
      "& .MuiOutlinedInput-input": {
        color: "white"
      },
      "&:hover .MuiOutlinedInput-input": {
        color: "white"
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
        color: "white"
      },
      "& .MuiInputLabel-outlined": {
        color: "white"
      },
      "&:hover .MuiInputLabel-outlined": {
        color: "white"
      },
      "& .MuiInputLabel-outlined.Mui-focused": {
        color: "white"
      }
    }
  }
}

export const editAddressApi = (async(addressData) => {
  
  const addrCollRef = collection(db, `users/${addressData.userId}/address`)
  return new Promise((resolve, reject)=> {
    updateDoc(doc(addrCollRef, addressData.addressId), addressData).then((querySnapshot) => {
      resolve({})
    }).catch((error)=> {
      reject(error)
    })
  })
})

export const deleteAddress = (async(addressData) => {
  
  const addrCollRef = collection(db, `users/${addressData.userId}/address`)
  return new Promise((resolve, reject)=> {
    deleteDoc(doc(addrCollRef, addressData.addressId)).then((querySnapshot) => {
      resolve({})
    }).catch((error)=> {
      reject(error)
    })
  })
})
  


export const addCartDataToFb = (async(userId, data) => {

  return new Promise((resolve, reject)=> {
    // setDoc(doc(cartRef, userId), data, { merge: true }).then((querySnapshot) => {
    //   resolve({})
    // }).catch((error)=> {
    //   reject(error)
    // })

    let newData = {
      userId : userId,
      ...data
    }

    fetch(`${process.env.REACT_APP_SERVER_URL}/v1/addToCart`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(newData)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })

  })
})

export const deleteCartDataFromFb = (async(userId) => {
  const cartRef = collection(db, `cart`)

  return new Promise((resolve, reject)=> {
    deleteDoc(doc(cartRef, userId)).then((querySnapshot) => {
      resolve({})
    }).catch((error)=> {
      reject(error)
    })
  })
})

export const generateAuthKey = (async(params) => {

  let userId, customerId

  if (params?.customerId) {
    userId = params.userId
    customerId = params.customerId
  } else {
    userId = (await Preferences.get({ key: 'userId' })).value
    customerId = (await Preferences.get({ key: 'customerId' })).value
  }

  if (userId) {
    const { nid } = await Preferences.get({ key: 'NID' })
    if (!nid) {
      var ciphertext = CryptoJS.AES.encrypt(userId, `hashkeyciphersalt${customerId}`).toString();
      const setAuthKey = await Preferences.set({key : 'NID', value : ciphertext})
    } 
  } 
})

export const getStockAvailability = (async(data) => {
  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/getStock`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    }).then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const updateBlogPost = (async(postId, blogData) => {
  return new Promise((resolve, reject)=> {
    // First, check if URL ID is unique (if changed)
    const checkUrlUniqueness = async () => {
      // Get the current post's urlId
      const docRef = doc(db, `blogPosts/${postId}`);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        reject({ error: "Blog post not found" });
        return false;
      }
      
      const currentPostData = docSnap.data();
      
      // If URL ID hasn't changed, no need to check uniqueness
      if (currentPostData.urlId === blogData.urlId) {
        return true;
      }
      
      // If URL ID has changed, check if the new one is unique
      const urlExists = await checkUrlIdExists(blogData.urlId);
      if (urlExists) {
        reject({ error: "URL ID already exists. Please choose a unique URL ID." });
        return false;
      }
      
      return true;
    };
    
    checkUrlUniqueness().then((canProceed) => {
      if (!canProceed) return;
      
      // Add updatedAt timestamp
      const updatedBlogData = {
        ...blogData,
        updatedAt: new Date()
      };
      
      // Update the blog post
      updateDoc(doc(db, `blogPosts/${postId}`), updatedBlogData).then(() => {
        resolve({ id: postId, ...updatedBlogData });
      }).catch((error) => {
        console.error("Error updating blog post:", error);
        reject(error);
      });
    }).catch((error) => {
      console.error("Error checking URL uniqueness:", error);
      reject(error);
    });
  });
});

export const deleteBlogPost = (async(postId) => {
  return new Promise((resolve, reject)=> {
    deleteDoc(doc(db, `blogPosts/${postId}`)).then(() => {
      resolve({ success: true });
    }).catch((error)=> {
      console.error("Error deleting blog post:", error);
      reject(error);
    });
  });
});

export const getStoreFromPods = async(latLong) => {
  return new Promise(async(resolve, reject) => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/v1/getStoreFromPods`, {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({ latLong })
    })
    .then((response) => response.json())
    .then(function(data) { 
      resolve(data)
    })
    .catch((error) => {
      console.log("Error fetching store from pods:", error)
      reject(error)
    })
  })
}


export const getPilotBranchInfo = (async(data) => {
  return new Promise(async(resolve, reject) => {
    if (data.deliveryDate == 'Today' ) {
      data.deliveryDate = new Date().toISOString().split('T')[0]
    } else if (data.deliveryDate == 'Tomorrow') {
      data.deliveryDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    }
      const podIdQuery = data?.podId ? `&podId=${encodeURIComponent(data.podId)}` : ''
      const appUpdateResp = await fetch(`${process.env.REACT_APP_PILOT_URL}/api/time-slots?storeId=${data.storeId}&deliveryDate=${data.deliveryDate}${podIdQuery}`, {
      "method": "GET",
      "headers": {
        "accept": "application/json"
      }
    }).then((response) => response.json())
    .then(function(data) { 
      resolve({slots : data.timeSlots})
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
})

export const getPilotProducts = (async(params = {}) => {
  return new Promise(async(resolve, reject) => {
    try {
      const { category, status = 'active', page = 1, limit = 100 } = params;
      
      // Check if PILOT_URL is set
      if (!process.env.REACT_APP_PILOT_URL) {
        reject({
          success: false,
          message: 'Pilot server URL is not configured',
          error: 'REACT_APP_PILOT_URL environment variable is missing'
        });
        return;
      }
      
      // Build query string
      const queryParams = new URLSearchParams();
      if (category) queryParams.append('category', category);
      if (status) queryParams.append('status', status);
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      
      const url = `${process.env.REACT_APP_PILOT_URL}/api/products?${queryParams.toString()}`;
      console.log('Fetching products from:', url);
      
      // Add timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "accept": "application/json",
          "content-type": "application/json"
        },
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      const data = await response.json();
      
      if (!response.ok) {
        reject({
          success: false,
          message: data.message || 'Failed to fetch products',
          error: data.error
        });
        return;
      }
      
      resolve(data);
    } catch (error) {
      console.error('Error fetching pilot products:', error);
      if (error.name === 'AbortError') {
        reject({
          success: false,
          message: 'Request timeout - server took too long to respond',
          error: 'Timeout error'
        });
      } else {
        reject({
          success: false,
          message: 'Failed to fetch products',
          error: error.message
        });
      }
    }
  });
})

const IN_STORE_DISTANCE_METERS = 70;

/**
 * Get nearest store by user coordinates (Haversine)
 * Used for in-store pilot orders - customer must be within 70m of store
 */
export const getNearestStoreHaversine = (lat, lng) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!process.env.REACT_APP_PILOT_URL) {
        reject({
          success: false,
          message: 'Pilot server URL is not configured',
          error: 'REACT_APP_PILOT_URL environment variable is missing'
        });
        return;
      }

      const url = `${process.env.REACT_APP_PILOT_URL}/api/store-selection/nearest-haversine`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({ lat, lng })
      });

      const data = await response.json();

      if (!response.ok) {
        reject({
          success: false,
          message: data.message || 'Failed to find nearest store',
          error: data.error
        });
        return;
      }

      if (!data.success || !data.data) {
        reject({
          success: false,
          message: 'Invalid response from store selection',
          error: 'Invalid response'
        });
        return;
      }

      const { store, distance } = data.data;

      if (distance?.meters > IN_STORE_DISTANCE_METERS) {
        reject({
          success: false,
          message: 'Please visit our store and scan the QR code to order',
          error: 'NOT_IN_STORE',
          distance: distance?.meters
        });
        return;
      }

      resolve({
        success: true,
        store,
        distance: data.data.distance
      });
    } catch (error) {
      console.error('Error fetching nearest store:', error);
      reject({
        success: false,
        message: error.message || 'Failed to find nearest store',
        error: error.message
      });
    }
  });
}